/**
 * Created by AlexanderC on 11/10/15.
 */

//https://github.com/eslint/eslint/issues/5150
/*eslint no-return-assign: 0*/

'use strict';

/**
 * @todo: Rename to Proxy
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

let MethodsProxy = exports.MethodsProxy = function () {
  /**
   * @param {Object} target
   */
  function MethodsProxy(target) {
    _classCallCheck(this, MethodsProxy);

    this._target = target;
    this._decorator = null;
  }

  /**
   * @returns {Object}
   */


  _createClass(MethodsProxy, [{
    key: 'decorate',


    /**
     * @param {Function} decorator
     * @returns {MethodsProxy}
     */
    value: function decorate(decorator) {
      this._decorator = decorator;

      return this;
    }

    /**
     * @param {Object} handler
     * @param {String|String[]} explMethods
     * @returns {Object}
     */

  }, {
    key: 'proxyOverride',
    value: function proxyOverride(handler) {
      var _this = this;

      for (var _len = arguments.length, explMethods = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        explMethods[_key - 1] = arguments[_key];
      }

      let methods = Object.keys(handler).concat(explMethods);

      for (let i in methods) {
        if (!methods.hasOwnProperty(i)) {
          continue;
        }

        let prop = methods[i];

        if (!handler.hasOwnProperty(prop) && explMethods.indexOf(prop) === -1) {
          continue;
        }

        if (typeof handler[prop] === 'function') {
          Object.defineProperty(this._target, prop, {
            value: function value() {
              for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                args[_key2] = arguments[_key2];
              }

              return typeof _this._decorator === 'function' ? _this._decorator.apply(_this, [handler, prop].concat(args)) : handler[prop].apply(handler, args);
            }
          });
        }
      }

      return this._target;
    }

    /**
    * @param {String} handler
    * @param {Object[]} explProps
    * @returns {Object|*}
    */

  }, {
    key: 'proxyProperties',
    value: function proxyProperties(handler) {
      for (var _len3 = arguments.length, explProps = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        explProps[_key3 - 1] = arguments[_key3];
      }

      let propList = Object.keys(handler).concat(explProps);

      for (let prop of propList) {
        if (typeof handler[prop] === 'function') {
          continue;
        }

        let descriptor = Object.getOwnPropertyDescriptor(handler, prop);
        let targetDescriptor = {
          enumerable: descriptor.enumerable,
          configurable: descriptor.configurable,
          get: () => handler[prop]
        };

        if (descriptor.writable) {
          targetDescriptor.set = value => handler[prop] = value;
        }

        Object.defineProperty(this._target, prop, targetDescriptor);
      }

      return this._target;
    }

    /**
     * @param {Object} handler
     * @param {String|String[]} explMethods
     * @returns {Object}
     *
     * @todo Replace typeof hook with hasOwnProperty() when get rid of babel
     */

  }, {
    key: 'proxy',
    value: function proxy(handler) {
      for (var _len4 = arguments.length, explMethods = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        explMethods[_key4 - 1] = arguments[_key4];
      }

      return this.proxyOverride.apply(this, [handler].concat(_toConsumableArray(explMethods.filter(prop => typeof this._target[prop] === 'undefined'))));
    }
  }, {
    key: 'target',
    get: function get() {
      return this._target;
    }
  }]);

  return MethodsProxy;
}();


//////////////////
// WEBPACK FOOTER
// ../~/deep-core/lib.compiled/Generic/MethodsProxy.js
// module id = 371
// module chunks = 0